import axiosClient from "utils/api";
const URI = "/admin/getApps";

export const getAppsUrl = async (payload) => {
  const URL = `${URI}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Get apps url:", error);
    throw error;
  }
};

export const updateAppsUrl = async (payload) => {
  const URL = `${URI}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Add apps url:", error);
    throw error;
  }
};